import { useMutation } from '@tanstack/react-query';

import { SafetyEventClient } from '../../clients';
import queryKeys from '../../queryKeys';
import { apiBaseUrl } from '../../../config';

const safetyEventClient = new SafetyEventClient(apiBaseUrl);

function useDeleteSafetyEventDraft() {
  return useMutation({
    mutationKey: [queryKeys.SafetyEvent.Delete],
    mutationFn: (id: number) => safetyEventClient.delete(id),
  });
}

export default useDeleteSafetyEventDraft;
